import AccessTimeIcon from '@mui/icons-material/AccessTime'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import DateRangeIcon from '@mui/icons-material/DateRange'
import EventIcon from '@mui/icons-material/Event'
import PersonIcon from '@mui/icons-material/Person'
import { Box, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { formatStringDate } from '../../../store/utils/dateUtils'

type WeeklyCalendarTooltipProps = {
  children: ReactElement
  mentee: string
  day: string
  hour: string
  isWorkingRangeTooltip: boolean
}

type WeeklyCalendarTooltipContentProps = {
  children: ReactElement
  content: string
}

const WeeklyCalendarTooltipContent = ({ children, content }: WeeklyCalendarTooltipContentProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="left"
      alignItems="center"
      gap="16px"
      sx={{ marginLeft: '16px', marginTop: '8px' }}
    >
      {children}
      <Typography variant="body2">{content}</Typography>
    </Stack>
  )
}

export const WeeklyCalendarTooltip = ({
  children,
  mentee,
  day,
  hour,
  isWorkingRangeTooltip,
}: WeeklyCalendarTooltipProps) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Tooltip
      placement="right"
      arrow
      followCursor
      title={
        <Box
          sx={{
            maxHeight: 250,
            padding: 0,
            overflowY: 'auto',
            width: 'auto',
            paddingY: '8px',
            paddingX: '16px',
          }}
        >
          <Stack gap="0px">
            <Stack direction="row" justifyContent="left" alignItems="center" gap="16px">
              {isWorkingRangeTooltip ? (
                <EventIcon sx={{ color: theme.palette.primary.light }}></EventIcon>
              ) : (
                <BeachAccessIcon sx={{ color: '#03a9f4' }}></BeachAccessIcon>
              )}
              <Typography variant="h5">
                {isWorkingRangeTooltip ? t('components.tooltip.workHours') : t('components.tooltip.vacation')}
              </Typography>
            </Stack>
            <WeeklyCalendarTooltipContent content={mentee}>
              <PersonIcon fontSize="small" />
            </WeeklyCalendarTooltipContent>
            <WeeklyCalendarTooltipContent content={formatStringDate(day)}>
              <DateRangeIcon fontSize="small" />
            </WeeklyCalendarTooltipContent>
            <WeeklyCalendarTooltipContent content={hour}>
              <AccessTimeIcon fontSize="small" />
            </WeeklyCalendarTooltipContent>
          </Stack>
        </Box>
      }
    >
      {children}
    </Tooltip>
  )
}
